// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"d571103b0c2a5fa8","6219":"6cb3453053eafbe7","7922":"6cb3453053eafbe7"}[chunkId] + ".css";
};